import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    // Save Validation
    Name: false,
    WildfireAcres: false,
    FireCode: false,
    IrwinID: false,
    DiscoveryDate: false,
    ContainDate: false,
    IgnitionFiscalYear: false,
    ID: false,
    CreatedBy: false,
    CreatedOnDate: false,
    LastModifiedBy: false,
    LastModifiedDate: false,
    OBJECTID: false,
    SourceSystemID: false,
    SourceSystemName: false,
    Notes: false,
    EntityType: false,
    IsFirePerimeter: false,
};

export const projectValidationSlice = createSlice({
    name: 'projectValidation',
    initialState,
    reducers: {
        resetProjectValidationState: (state) => {
            for (const prop in state) {
                if (initialState[prop] !== null) {
                    state[prop] = false;
                } else {
                    delete state[prop];
                }
            }
        },
        genericEditFieldToggle: (state, action) => {
            if (state[action.payload] === null) {
                return;
            }
            state[action.payload] = !state[action.payload];
        },
        genericProjectValidationFieldSetTrue: (state, action) => {
            if (state[action.payload] === null) {
                return;
            }
            state[action.payload] = true;
        },
        genericProjectValidationFieldSetFalse: (state, action) => {
            if (state[action.payload] === null) {
                return;
            }
            state[action.payload] = false;
        },
    },
});

export const {
    genericEditFieldToggle,
    genericProjectValidationFieldSetTrue,
    genericProjectValidationFieldSetFalse,
    resetProjectValidationState,
} = projectValidationSlice.actions;

export default projectValidationSlice.reducer;
